import React from "react";
import Pagetitle from "./component/Pagetitle";
import MyAccountNav from "./component/MyAccountNav";
import AddressManagement from "./AddressManagement";

function MyAccountAddress() {
  return (
    <>
      <Pagetitle title="Addresses" />
      <section className="flat-spacing-11">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <MyAccountNav activeLink="address" />
            </div>
            <div className="col-lg-9">
              <div className="my-account-content account-address">
                <AddressManagement></AddressManagement>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default MyAccountAddress;
